export const MIN_LANE_WINDOW_HOURS = 1;
export const MAX_LANE_WINDOW_HOURS = 240; // 10 days

export function isValidLaneWindowHours(hours: number | undefined | null): hours is number {
    return typeof hours === "number" && Number.isFinite(hours) && hours >= MIN_LANE_WINDOW_HOURS && hours <= MAX_LANE_WINDOW_HOURS;
}
